/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Upsell_CtaInputs */

const fr_plan_upsell_cta = /** @type {(inputs: Plan_Upsell_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir ma formule`)
};

/**

* @param {Plan_Upsell_CtaInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plan_upsell_cta = /** @type {((inputs?: Plan_Upsell_CtaInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Upsell_CtaInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plan_upsell_cta(inputs)
});